import { VehicleRemark } from '~/apiClient';

const vehicleRemarkOrder = [
    VehicleRemark.MILEAGE_UNCERTAIN_TRUST_REPORT,
    VehicleRemark.MILEAGE_UNCERTAIN_LAST_INSPECTION,
    VehicleRemark.E5EEV_PARTICULATE_CLASSIFICATION,
    VehicleRemark.CNG_DUAL_FUEL_SYSTEM,
    VehicleRemark.CNG_CYLINDER_INSPECTION_BUYER_EXPENSE,
    VehicleRemark.MORTGAGE_EXPIRED_ENFORCEABILITY,
    VehicleRemark.SPAIN_INDIVIDUAL_APPROVAL_PRE_2012,
    VehicleRemark.ITALY_FOREIGN_DOCS_NATIONALIZATION,
    VehicleRemark.DELIVERY_DELAY_LEASING_15_DAYS,
    VehicleRemark.DELIVERY_DELAY_10_DAYS,
    VehicleRemark.DELIVERY_DELAY_20_DAYS,
    VehicleRemark.DELIVERY_DELAY_30_DAYS,
    VehicleRemark.DELIVERY_DELAY_45_DAYS,
    VehicleRemark.DELIVERY_DELAY_60_DAYS,
    VehicleRemark.DISMANTLING_TECHNICAL_FLUIDS_PRESENT,
    VehicleRemark.DISMANTLING_FLUIDS_AND_CNG_PRESENT,
    VehicleRemark.BRANDING_OBSCURED_FOR_PRIVACY,
] as const satisfies readonly VehicleRemark[];

export const sortVehicleRemarks = (vehicleRemarks: VehicleRemark[]): VehicleRemark[] =>
    vehicleRemarks?.toSorted((a, b) => vehicleRemarkOrder.indexOf(a) - vehicleRemarkOrder.indexOf(b));
